import * as Actions from '../actions';

const initialState = {
	job: null,
	list: [],
	error: null,
	selected: null,
	searchText: ''
};

const jobReducer = (state = initialState, action) => {
	switch (action.type) {
		// SUCCESS
		case Actions.SET_JOB: {
			return {
				...state,
				job: action.payload
			};
		}

		case Actions.SET_JOB_LIST: {
			return {
				...state,
				list: action.payload
			};
		}
		case Actions.SET_JOB_ERROR: {
			return {
				...state,
				error: action.payload
			};
		}
		case Actions.SET_SEARCH_TEXT: {
			return {
				...state,
				searchText: action.searchText
			};
		}
		// SELECTED
		case Actions.SET_SELECTED: {
			return {
				...state,
				selected: action.payload
			};
		}
		// CLEAR
		case Actions.CLEAR_JOB: {
			return {
				...state,
				job: null
			};
		}
		case Actions.CLEAR_ERROR: {
			return {
				...state,
				error: null
			};
		}
		case Actions.CLEAR_JOBS_REDUCER: {
			return initialState;
		}

		// DEFAULT
		default: {
			return state;
		}
	}
};

export default jobReducer;
